import React, { useContext, useEffect, useState } from "react";
import { PartenerSheepDeedService } from "../services/parternshipservice";
import HomeCounters from "./Homecounters";
import Testimonials from "./Testimonial";
import WhatsAppScrollButton from "./floatingwhatsApp";
import CircularScrollProgress from "./Circularprogress";
import Footer from "./footer";
import CitySelector from "./User/CitySelectore";
import { ServicesContext } from "../services/ServicesContext";
import { handleRazorpayPayment } from "../services/handlePayment";
import AuthUser from "../services/AuthUser";
import { useNavigate } from "react-router-dom";


function GSTregistration() {


   useEffect(() => {
      const storedUser = localStorage.getItem("user");
      if (storedUser) {
        const parsedUser = JSON.parse(storedUser);
        setNewData((prevData) => ({
          ...prevData,
          user_name: parsedUser.name || "",
          user_email_address: parsedUser.email || "",
          user_phone_number: parsedUser.mobile || "",
          user_city: parsedUser.city || "",
        }));
      }
    }, []);

   const [activeQuestion, setActiveQuestion] = useState(null);
     const { http, token } = AuthUser();
   const navigate = useNavigate();
   const toggleQuestion = (questionId) => {
      setActiveQuestion((prev) => (prev === questionId ? null : questionId));
   };


   const [newData, setNewData] = useState({ user_name: '', user_city: '', user_email_address: '', user_phone_number: '' });
   const [errors, setErrors] = useState({});
      const { services, loading, error } = useContext(ServicesContext);  
      if (loading) {
         return <div>Loading...</div>;  // Show loading state while fetching data
     }
   
     if (error) {
          return <div>{error}</div> // Show error state if there was an issue fetching data
     }
      const service = services.find(s => s.service_id === 13);

   const validateForm = () => {
      const newErrors = {};

      // Name validation
      if (!newData.user_name.trim()) {
         newErrors.user_name = 'Name is required.';
      } else if (!/^[a-zA-Z\s]+$/.test(newData.user_name)) {
         newErrors.user_name = '*Name should only contain letters and spaces.';
      }

      // Email validation
      if (!newData.user_email_address.trim()) {
         newErrors.user_email_address = 'Email address is required.';
      } else if (!/\S+@\S+\.\S+/.test(newData.user_email_address)) {
         newErrors.user_email_address = 'Enter a valid email address.';
      }

      // Phone number validation
      // if (newData.user_phone_number && !/^\d{10}$/.test(newData.user_phone_number)) {
      //    newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
      // }

      if (!newData.user_phone_number.trim()) {
         newErrors.user_phone_number = 'number is required.';
       } else if (!/^\d{10}$/.test(newData.user_phone_number)) {
         newErrors.user_phone_number = 'Enter a valid 10-digit contact number.';
       }


      // City validation
      if (!newData.user_city) {
         newErrors.user_city = 'City/District is required.';
      }

      setErrors(newErrors);
      return Object.keys(newErrors).length === 0; // Returns true if no errors
   };



    const formPutPartenshipdeed = async (e) => {
                e.preventDefault();
                    // ✅ Check if user is logged in
       // if (!token) {
      //     alert("Please log in to continue.");
      //    localStorage.setItem("redirectAfterLogin", window.location.pathname); // ⬅️ Save current path
      //    navigate('/login'); // 👈 Use this if you're using React Router
      //    return;
      // }
                if (!validateForm()) return;
              
                 localStorage.setItem("bookingData", JSON.stringify(newData));

      // Navigate to checkout
      navigate('/checkout', {
         state: {
            service: service,

         }
      });
                 
              };

              const handleBannerClick = () => {
  const formElement = document.querySelector(".contact3-form-all");

  if (formElement) {
    formElement.classList.add("shake-effect");

    // remove effect after animation finishes
    setTimeout(() => {
      formElement.classList.remove("shake-effect");
    }, 400); // same as animation duration
  }
};


   return (
      <div>


         <div className="hero-area10 header-background">
            <div className="container">
               <div className="row">
                  <div className="col-lg-8">
                     <div className="title title2 ">
                        <div className="headding-shape aniamtion-key-2">
                           <img src="assets/img/shapes/hero8-shape2.svg" alt="" />
                        </div>
                        <h1 className="sk-text-color">GST Registration</h1>
                        <p className="pdrl-text">Get GST Registration for only <span className="text-color"> Rs.{service?.price}/- </span> <span>(Final Price, No Hidden Costs)</span></p>
                        <p className="pd-text">Get your business GST-registered quickly and effortlessly! Our experts handle the entire process, ensuring compliance and a smooth experience—so you can focus on growth while we take care of the paperwork.</p>
                        <p className="pd-text">GST registration is essential for businesses, and a smooth process is key. With Dm2Legal, you can register effortlessly and focus on growth. Under GST laws, businesses with a turnover above ₹40 lakhs (₹10 lakhs for North Eastern & hill states) must register as regular taxpayers. The process usually takes 2 to 6 working days.</p>
                       <div className="banner" onClick={handleBannerClick}>
   <img src="assets/icons/banner.svg" alt="" />
</div>

                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img className="hero9-shape3 aniamtion-key-1" src="assets/img/shapes/hero9-shape.svg" alt="" />
                     <div className="contact3-form-all">
                        <div className="hadding7">
                           <h3>Book Service Now </h3>
                           <p className="pdrl-text">at Rs.{service?.price}/- Only <br /> <span>(Final Price, No Hidden Costs)</span></p>
                        </div>

                        <form action="#">
                           <div className="form-input-all">
                              <div className="form-input-box">
                                 <div className="row">
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Name<span className="red">*</span></label> {errors.user_name && <p className="error-text">{errors.user_name}</p>}
                                             <input type="text" placeholder="Enter your Name" value={newData.user_name} onChange={(e) => setNewData({ ...newData, user_name: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Email Address<span className="red">*</span></label>{errors.user_email_address && <p className="error-text">{errors.user_email_address}</p>}
                                             <input type="email" placeholder="Enter your Email Address" value={newData.user_email_address} onChange={(e) => setNewData({ ...newData, user_email_address: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-md-12">
                                       <div className="input-single6">
                                          <div className="">
                                             <label htmlFor="">Contact Number<span className="red">*</span></label> {errors.user_phone_number && <p className="error-text">{errors.user_phone_number}</p>}
                                             <input type="number" placeholder="Enter your Contact Number" value={newData.user_phone_number} onChange={(e) => setNewData({ ...newData, user_phone_number: e.target.value })} />
                                          </div>
                                       </div>
                                    </div>
                                    <div className="col-12">
                                    <CitySelector
                                          newData={newData}
                                          setNewData={setNewData}
                                          fieldKey="user_city"
                                          errors={errors}
                                       />
                                    </div>
                                 </div>
                              </div>
                              <div className="space20"></div>
                              <div className="btn-group-2">
                                 <a className="theme-btn-3" onClick={formPutPartenshipdeed} href="#">Proceed now <span><i className="fa-solid fa-arrow-right"></i></span></a>
                              </div>
                           </div>
                        </form>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space60 bg-white"></div>

         <div className="home4-counters bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-md-12">


                     <HomeCounters />
                  </div>
               </div>


               <div className="space40"></div>
               <div className="row">
                  <div className="col-lg-12">
                     <p className="pd-text"> India has three types of GST: CGST, SGST, and IGST, which help differentiate inter-state and intra-state transactions while reducing indirect taxes. CGST (Central Goods and Services Tax) is collected by the Central Government, SGST (State Goods and Services Tax) by the State Government, and IGST (Integrated Goods and Services Tax) applies to inter-state transactions based on the location of the supply.</p>

                     <p className="pd-text">For inter-state transactions, IGST is collected, combining taxes for both the State and Central governments. For intra-state transactions, SGST goes to the State Government, while CGST goes to the Central Government. The application of CGST, SGST, and IGST depends on the transaction location.</p>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">How to apply</h2>
                        <div className="space20"></div>
                        <img src="assets/img/images/GST-Registration.png" alt="" />
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Benefits of Getting GST Registration Done through Dm2Legal</h2>
                        <div className="space40"></div>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-9.png" alt="" />
                        </div>
                        <h3>Budget-Friendly Service</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>No Hidden Charges</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Helps in Documentation</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-12.png" alt="" />
                        </div>
                        <h3>Reduces cascading effect</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-13.png" alt="" />
                        </div>
                        <h3>Ease of Purchase</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-14.png" alt="" />
                        </div>
                        <h3>Decreased Complex GST Registration</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-15.png" alt="" />
                        </div>
                        <h3>After Service Support</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-16.png" alt="" />
                        </div>
                        <h3>Best Virtual Assistance</h3>
                     </div>
                  </div>
                  <div className="col-md-4 col-lg-3 col-sm-6">
                     <div className="single-service text-center">
                        <div className="service-icon bg-24">
                           <img src="assets/img/icons/service-10.png" alt="" />
                        </div>
                        <h3>Smooth Online Registration Process</h3>
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Avoiding Common Mistakes in GST Registration</h2>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="hadding7">

                        <div className="contact6-list">
                           <ul>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Filling of incorrect personal details</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Choosing the wrong type of GST Registration</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Uploading illegible documents</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Ignoring the threshold limit set by the government</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>More than a single registration for the same business</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Opting for the wrong GST category</li>
                              <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Not keeping an eye on the GST Registration Status</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <img src="assets/img/images/Avoiding-Common-Mistakes-in-GST-Registration.png" alt="" />
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">Documents Required for GST Registration</h2>
                        <div className="space40"></div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Sole Proprietorship / Individual</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of the sole proprietor</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <p>Own office:  Office address proof:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental Agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Partnership deed / LLP Agreement</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of partners</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Deed / Agreement Firm PAN Card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-4 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4>HUF</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar card of Karta</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Karta</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photo of Applicant</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of HUF</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; HUF Deed Document</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>

               </div>
               <div className="row">
                  <div className="col-lg-6 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Society / Trust / Club</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhaar card of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN Card of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photo of President / Secretary</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Society / Club / Trust</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Registration</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Proof of authorized signatory- Board Resolution</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6 aos-init aos-animate">
                     <div className="single-price">
                        <div className="price-heading">
                           <h4 >Private limited / Public limited / One person company</h4>
                        </div>
                        <div className="price-body">
                           <ul>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Aadhar card of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; PAN card of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Photograph of Directors</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Bank statement or a canceled cheque</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Company’s PAN card</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Certificate of Registration</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; MOA (Memorandum of Association)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; AOA (Articles of Association)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Office address proof:</li>
                              <p>Own office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Copy of Registry</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <p>Rented office:</p>
                              <ul>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Rental agreement</li>
                                 <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Property Tax Receipt</li>
                              </ul>
                              <div className="space10"></div>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Proof of authorized signatory- Board Resolution</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Shop & Establishment License (Gumasta)</li>
                              <li><span className="pricing-icon"><img className="doc" src="assets/image/doc-01.svg" alt="" /></span>&nbsp; Trade License (Municipal Corporation)</li>
                           </ul>
                        </div>
                     </div>
                  </div>
               </div>

               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">GST Registration: Importance for Business Growth</h2>
                     </div>
                  </div>
                  <div className="col-lg-4">
                     <img src="assets/img/images/GST-Registration-Importance-for-Business-Growth.png" alt="" />
                  </div>
                  <div className="col-lg-8">
                     <div className="space30"></div>
                     <p className="pd-text">GST registration is a key step in scaling your business. It not only ensures tax compliance but also streamlines your financial operations, enhancing transparency and credibility. With GST, your business gains access to a broader market, making expansion across regions seamless and hassle-free. Stay ahead with a compliant and trusted business identity!</p>
                     <p className="pd-text">Moreover, GST registration paves the way for business growth and strategic partnerships. It enables you to bid for government contracts and tenders, unlocking new opportunities and expanding your market reach. A registered business also gains trust and recognition, helping you build a strong and credible brand identity.</p>
                     <p className="pd-text">Finally, GST registration optimizes your supply chain, reducing tax complexities and enhancing operational efficiency. It also provides financial advantages, enables seamless interstate trade, and positions your business for long-term success in a competitive market. Stay compliant, expand effortlessly, and drive sustainable growth with GST registration</p>
                  </div>
               </div>
               <div className="row">
                  <div className="col-lg-12">
                     <div className="hadding7">
                        <div className="space40"></div>
                        <h2 className="text-center">GST Registration for Small Businesses</h2>
                        <div className="space20"></div>
                        <p className="pd-text">For small businesses, GST registration offers several benefits, including the ability to claim input tax credits. It also simplifies the selling of goods and services across states and provides legal protection, as operating without GST registration can result in significant penalties.</p>
                        <div className="space20"></div>
                        <p className="pd-text">However, small businesses should seek professional advice. Our experienced legal experts are here to provide you with the right information and guidance for your GST registration. GST has revolutionized the operations of small businesses by simplifying taxation policies and easing their workflows. It also helps businesses expand across borders and enhances their credibility in the market.</p>
                        <div className="space20"></div>
                        <p className="pd-text">Additionally, small businesses can gain better access to loans by complying with GST regulations. GST registration can be completed easily with the necessary documents. Furthermore, GST registration offers financial benefits to small businesses, along with streamlined trade processes.</p>
                        <div className="space20"></div>
                     </div>
                  </div>
                  <div className="col-lg-7">
                     <div className="contact6-list doc-list">
                        <ul>
                           <p><strong>Following are some important points of GST Registration of small businesses:</strong></p>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Improved ease of doing business</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Unified taxation</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Composition Scheme</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Increased credibility</li>
                           <li className="font-f-7"><span><img className="arow" src="assets/image/arow-01.svg" alt="" /></span>Easy access to credit</li>
                        </ul>
                     </div>
                  </div>
                  <div className="col-lg-5">
                     <div className="contact6-list doc-list">
                        <img src="assets/img/images/GST-Registration-for-Small-Businesses.png" alt="" />
                     </div>
                  </div>
               </div>

               <div className="space20"></div>

            </div>
         </div>


         <div className="service-binifits9 sp0" id="service2" >
            <div className="space50"></div>
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 text-center">
                     <div className="hadding7">

                        <h2 >GST Registration Process Explained </h2>
                     </div>
                     <div className="partnership-deade-section">
                        <div className="space40"></div>

                        <ul className="disc-list">
                           <li>
                              <h3>Step 1 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>GST registration is mandatory for every dealer whose annual turnover exceeds Rs.20 Lakh (this threshold may vary based on the state and type of supplies).</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 2 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>The GST registration process is simple and can be completed online through the government website gst.gov.in. All you need to do is fill out the GST REG-01 form.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 3 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>The GST REG-01 form consists of two parts: Part A and Part B. It is mandatory to fill out both sections with accurate information.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 4 <span><img className="arow" src="assets/image/blackarow.svg" alt="" /></span></h3>
                              <span>According to the GST Act, GST registration requirements vary for regular taxpayers, casual taxable persons, composition taxpayers, and non-resident taxpayers.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                           <li>
                              <h3>Step 5 <span><img className="arow" src="assets/image/done.svg" alt="" /></span></h3>

                              <span>The advantage of GST registration is that it legally recognizes your business and allows you to avail all the benefits provided under the GST framework.</span>
                              <svg className="pointer">
                                 <path d="M6.25,1.25L11.25,11.25L1.25,11.25L6.25,1.25Z" />
                              </svg>
                           </li>
                        </ul>

                        <div className="space80"></div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="bg-white">

         </div>



         <div className="bg-white">

            <div className="container ">


               <div className="row">
                  <div className="col-12">
                     <div className="faq-items" id="masonry-grid">
                        <div className="mesonry-item general single-price-list">
                           <div className="faqs inner-faq">
                              <h2 className="text-center">FAQs on GST Registration </h2>

                              <div id="general">


                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 1 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(1)}
                                    >
                                       Q1: What is GST Registration?
                                       <span>
                                          {activeQuestion === 1 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 1 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">GST Registration is the process of registering a business under the Goods and Services Tax (GST) law, enabling it to collect and pay GST on sales, and claim input tax credits</p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 2 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(2)}
                                    >
                                       Q2: Why is GST Registration Needed?
                                       <span>
                                          {activeQuestion === 2 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 2 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">GST registration is required for businesses to legally collect GST, claim input tax credits, and ensure compliance with tax regulations. It also enhances business credibility and allows for smooth interstate transactions. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 3 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(3)}
                                    >
                                       Q3: When is GST Registration Required?
                                       <span>
                                          {activeQuestion === 3 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 3 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">GST registration is required when a business's turnover exceeds the threshold limit set by the government, or if the business deals in inter-state supply of goods or services, or engages in specific activities like e-commerce. </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 4 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(4)}
                                    >
                                       Q4: Documents Required for GST Registration
                                       <span>
                                          {activeQuestion === 4 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 4 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">For GST registration, the following documents are typically needed:<br/>

                                          1. PAN card of the business or applicant.<br/>
                                          2. Proof of business address (e.g., utility bill or rent agreement).<br/>
                                          3. Identity and address proof of the business owner (Aadhaar, Passport, etc.).<br/>
                                          4. Bank account statement or cancelled cheque.<br/>
                                          5. Business's legal constitution proof (e.g., partnership deed, certificate of incorporation).<br/>
                                          6. Digital Signature for certain types of businesses.</p><br/>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 5 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(5)}
                                    >
                                       Q5: Is the submission of hard copies of any documents required?
                                       <span>
                                          {activeQuestion === 5 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 5 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                          No, there is no need to submit hard copies of documents as the GST registration process is paperless.
                                       </p>
                                    </div>
                                 </div>
                                 <div className="single-faq">
                                    <h2
                                       className={`faq-heading font-f-3 weight-700 ${activeQuestion === 6 ? '' : 'collapsed'
                                          }`}
                                       id="faq-heading1"
                                       onClick={() => toggleQuestion(6)}
                                    >
                                       Q6:How is the new GST registration application verified?
                                       <span>
                                          {activeQuestion === 6 ? (
                                             <img src="assets/img/icons/plus-3.svg" className="minusicon" alt="" />
                                          ) : (
                                             <img src="assets/img/icons/plus-2.svg" className="plusicon" alt="" />


                                          )}
                                       </span>
                                    </h2>
                                    <div
                                       id="collapse1"
                                       className={`accordion-collapse collapse ${activeQuestion === 6 ? 'show' : ''
                                          }`}
                                    >
                                       <p className="font-f-3 weight-500">
                                       The verification process for a new GST registration involves document review, application scrutiny, and sometimes a field visit by the GST officer. Aadhaar-based authentication may also be required for quicker processing. Once verified, the GSTIN is issued.                                       </p>
                                    </div>
                                 </div>


                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>

         </div>


         <Testimonials />




         <div className="sp2 last-section bg-white">
            <div className="container">
               <div className="row">
                  <div className="col-lg-12 ">
                     <div className="hadding7">
                        <h2 className="text-center">Why Choose Dm2Legal for GST Registration Online?  </h2>
                     </div>
                  </div>
               </div>
               <div className="space30"></div>
               <div className="row">
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>1</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/reg.svg" alt="" /></span><a href="single-service-1.html" >Convenient Registration</a></h4>
                           <p>With the Dm2Legal mobile app or website, users can easily register online by simply providing their name, email ID, contact number, and required service. After completing your online registration, our team will get in touch with you and guide you through the next steps of the process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>2</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/online.svg" alt="" /></span><a href="single-service-1.html" >Best Online Platform</a></h4>
                           <p>Dm2Legal is one of the largest online platforms in India, with an extensive client base, making us a top choice for your GST registration needs. No matter where you are, we are ready to assist you online.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>3</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/customer.svg" alt="" /></span><a href="single-service-1.html" >Best Customer Support</a></h4>
                           <p>The Dm2Legal team is well-known for providing comprehensive support and assistance to our clients. We not only offer legal support after your GST registration but also value and welcome your feedback.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>4</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/team.svg" alt="" /></span><a href="single-service-1.html" >Experienced Team</a></h4>
                           <p>With over 10 years of expertise in the GST registration process, we are well-equipped to guide you. Choosing our team means you’ll work with experienced professionals who will streamline and simplify your GST registration process.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>5</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/support.svg" alt="" /></span><a href="single-service-1.html" >On-time Service</a></h4>
                           <p>Our team is committed to providing prompt, timely service. We understand the value of your time, so we begin working on your GST registration process immediately, ensuring no delays.</p>
                        </div>
                     </div>
                  </div>
                  <div className="col-lg-6">
                     <div className="service6-box">
                        <div className="">
                           <div className="service-box-icon">
                              <p>6</p>
                           </div>
                        </div>
                        <div className="hadding6">
                           <h4><span><img className="arow" src="assets/image/icons/friendly.svg" alt="" /></span><a href="single-service-1.html" >Pocket-friendly Services</a></h4>
                           <p>We provide budget-friendly services without compromising on quality. With every investment in our services, we prioritize both your satisfaction and budget, ensuring exceptional value.</p>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>

         <div className="space40 bg-white"></div>

         <WhatsAppScrollButton />
         <Footer />
         <CircularScrollProgress />

      </div>

   );
}
export default GSTregistration;